<template>
  <div style="position:absolute; left: -99999px; top: -99999px; width: 200vw;">
    <vue-office-docx
      :src="docxRenderer.url" 
      @rendered="docxRendered"/>
    <vue-office-pdf
      :src="pdfRenderer.url" 
      @rendered="pdfRendered"/>
    <vue-office-pptx 
      :src="pptxRenderer.url" 
      @rendered="pptxRendered"/>
  </div>
</template>

<script>
import VueOfficeDocx from '@vue-office/docx';
import VueOfficePptx from '@vue-office/pptx';
import VueOfficePdf from '@vue-office/pdf';
import { ApplicationContext } from '@/utils/context';
import html2canvas from "html2canvas";

export default {
  name: 'FileRenderer',
  components: {
    VueOfficeDocx,
    VueOfficePptx,
    VueOfficePdf
  },
  data: () => {
    return {
      pptxRenderer: { url: '' },
      pdfRenderer: { url: '' },
      docxRenderer: { url: '' }
    }
  },
  methods: {
    docxRendered() {
      let that = this;
      let timeoutId = null;
      const intervalId = setInterval(async () => {
          const wrappers = document.getElementsByClassName("docx");
          if (wrappers.length > 0) {
            clearInterval(intervalId); 
            let element = wrappers[0].children[0];
            element.style.textAlign = 'left';
            let canvas = await html2canvas(element);
            let ctx = canvas.getContext('2d');
            let image = ctx.getImageData(0, 0, canvas.width, canvas.height);
            canvas.width = canvas.width + 64;
            canvas.height = canvas.height + 64;
            canvas.style.margin = "32px";
            canvas.style.display = "block"; 
            ctx.fillStyle = "white";
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.putImageData(image, 32, 32); 
            ApplicationContext.$emit('finish_rendering_docx', {
              success: true, 
              canvas: canvas
            });
            that.docxRenderer.url = null;
            timeoutId && clearTimeout(timeoutId);
          }
      }, 100);
      timeoutId = setTimeout(() => {
        intervalId && clearInterval(intervalId); 
        ApplicationContext.$emit('finish_rendering_docx', {
          success: false
        });
        that.docxRenderer.url = null;
      }, 15000);
    },
    pptxRendered() {
      let that = this;
      let timeoutId = null;
      let intervalId = setInterval(() => {
          const slides = document.getElementsByClassName("pptx-preview-slide-wrapper");
          let elements = [];
          if (slides.length > 0) {
            clearInterval(intervalId); 
            for (let i = 0; i < slides.length; i++) {
              let slide = slides[i];
              slide.style.textAlign = 'left';
              elements.push(slide);
            }
            ApplicationContext.$emit('finish_rendering_pptx', {
              success: true, 
              elements: elements
            });
            that.pptxRenderer.url = null;
            timeoutId && clearTimeout(timeoutId);
          }
      }, 100);
      timeoutId = setTimeout(() => {
        intervalId && clearInterval(intervalId); 
        ApplicationContext.$emit('finish_rendering_pptx', {
          success: false
        });
        that.pptxRenderer.url = null;
      }, 15000);
    },
    pdfRendered() {
      let that = this;
      let timeoutId = null;
      const intervalId = setInterval(() => {
          let wrappers = document.getElementsByClassName('vue-office-pdf-wrapper');
          if (wrappers) {
            let wrapper = wrappers[0];
            let pages = wrapper.getElementsByTagName('canvas');
            if (pages && pages.length > 0) {
              clearInterval(intervalId); 
              ApplicationContext.$emit('finish_rendering_pdf', {
                success: true,
                pages: pages
              });
              that.pdfRenderer.url = null;
              timeoutId && clearTimeout(timeoutId);
            }
          }
      }, 100);
      timeoutId = setTimeout(() => {
        intervalId && clearInterval(intervalId); 
        ApplicationContext.$emit('finish_rendering_pdf', {
          success: false
        });
        that.pdfRenderer.url = null;
      }, 15000);
    }
  },
  mounted() {
    ApplicationContext.$on('do_rendering_docx', (buffer) => {
      this.docxRenderer.url = buffer;
    });
    ApplicationContext.$on('do_rendering_pptx', (buffer) => {
      this.pptxRenderer.url = buffer;
    });
    ApplicationContext.$on('do_rendering_pdf', (buffer) => {
      this.pdfRenderer.url = buffer;
    });
  },
  beforeDestroy() {
    ApplicationContext.$off('do_rendering_docx');
    ApplicationContext.$off('do_rendering_pptx');
    ApplicationContext.$off('do_rendering_pdf');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
